import React, { VFC } from 'react';
import { Platform } from 'react-native';

import { HStack, Icon, Text } from '@fhs-legacy/universal-components';
import { theme } from 'styles/configure-theme';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

interface IStoreActionsErrorProps {
  message: string;
  nativeID?: string;
}

export const StoreActionsError: VFC<IStoreActionsErrorProps> = ({ message, nativeID }) => {
  return (
    <HStack
      nativeID={nativeID}
      alignItems="center"
      justifyContent="center"
      background={theme.token('background-inline-alert')}
      paddingY="1"
      paddingX="1"
      accessible
      accessibilityRole={Platform.OS !== 'web' ? 'text' : undefined}
      accessibilityLabel={message}
      _web={
        {
          role: 'status',
          'aria-live': 'polite',
          'aria-atomic': true,
          tabIndex: 0,
        } as React.ComponentProps<typeof HStack>['_web']
      }
    >
      <Icon
        color={theme.token('text-default')}
        variant="error"
        size="14px"
        marginRight="1"
        {...hiddenAccessibilityPlatformProps}
      />
      <Text accessible={false} fontSize="xs" fontWeight="medium" color={theme.token('text-default')}>
        {message}
      </Text>
    </HStack>
  );
};
